import { render, staticRenderFns } from "./ToMallWeb.vue?vue&type=template&id=44b2f27b&scoped=true"
import script from "./ToMallWeb.vue?vue&type=script&lang=js"
export * from "./ToMallWeb.vue?vue&type=script&lang=js"
import style0 from "./ToMallWeb.vue?vue&type=style&index=0&id=44b2f27b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44b2f27b",
  null
  
)

export default component.exports